export default "__VITE_PUBLIC_ASSET__3829d379__"